import {Component, EventEmitter, Output} from '@angular/core';
import {MatChip, MatChipSet} from "@angular/material/chips";
import {MatButton} from "@angular/material/button";
import {MatDialog} from "@angular/material/dialog";
import {
  ApplicationsCriteriaComponent,
  StatusEnum
} from "../applications-criteria/applications-criteria.component";
import {CatalogResource} from "../../core/modules/openapi";

export interface AppSearchCriteria {
  type: string;
  value: string;
}

@Component({
  selector: 'app-applications-search',
  imports: [
    MatChipSet,
    MatChip,
    MatButton
  ],
  templateUrl: './applications-search.component.html',
  standalone: true,
  styleUrl: './applications-search.component.sass'
})
export class ApplicationsSearchComponent {
  criteriaData: ApplicationCriteriaData;
  @Output() updated = new EventEmitter();

  constructor(private readonly dialog: MatDialog) {
  }

  filters() {
    const dialogRef = this.dialog.open(ApplicationsCriteriaComponent, {"data": this.criteriaData});

    dialogRef.afterClosed().subscribe((result: ApplicationCriteriaData) => {
      if (result?.action === "SET") {
        console.log(result);
        this.criteriaData = result;
        localStorage.setItem("searchCriteria", JSON.stringify(this.criteriaData));
        this.updated.emit(this.criteriaData);
      }
    });
  }
}

export interface ApplicationCriteriaData {
  action: string;
  insurableInterestIdentifier: string;
  insuredId: string;
  insurerId: CatalogResource;
  status: [string, StatusEnum][];
}
